/* Loveda – Produktseite: Galerie, Varianten, Personalisierung, Warenkorb */
(function () {
  'use strict';

  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = format || '€{{amount}}';

    function defaultOption(opt, def) {
      return typeof opt === 'undefined' ? def : opt;
    }

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = defaultOption(precision, 2);
      thousands = defaultOption(thousands, '.');
      decimal = defaultOption(decimal, ',');
      if (isNaN(number) || number == null) return 0;
      number = (number / 100.0).toFixed(precision);
      var parts = number.split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var centsPart = parts[1] ? decimal + parts[1] : '';
      return dollars + centsPart;
    }

    var match = formatString.match(placeholderRegex);
    if (!match) return formatString;

    switch (match[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
      default:
        value = formatWithDelimiters(cents, 2);
    }
    return formatString.replace(placeholderRegex, value);
  }

  function findVariant(variants, selected) {
    return variants.find(function (v) {
      return v.options.length === selected.length && v.options.every(function (opt, i) {
        return opt === selected[i];
      });
    });
  }

  /* Hauptbild wechseln: srcset mit austauschen, damit Handy/Desktop passende Bildgrößen laden */
  function swapMainImage(mainImg, src, thumb) {
    if (!mainImg || !src) return;
    var srcset = thumb ? thumb.getAttribute('data-srcset') : null;
    if (srcset) {
      mainImg.srcset = srcset;
    } else {
      mainImg.removeAttribute('srcset');
    }
    mainImg.src = src;
  }

  function initGalleryArrows(gallery) {
    if (!gallery || gallery.dataset.lvArrowsInitialized === 'true') return;
    gallery.dataset.lvArrowsInitialized = 'true';

    var prevBtn = gallery.querySelector('[data-lv-gal-prev]');
    var nextBtn = gallery.querySelector('[data-lv-gal-next]');
    if (!prevBtn && !nextBtn) return;

    function getThumbs() {
      return Array.prototype.slice.call(gallery.querySelectorAll('[data-lv-thumb]'));
    }

    function activateThumb(thumb) {
      var thumbs = getThumbs();
      thumbs.forEach(function (t) {
        t.classList.remove('is-active');
      });
      thumb.classList.add('is-active');
      swapMainImage(gallery.querySelector('[data-lv-main-img]'), thumb.getAttribute('data-full'), thumb);
    }

    function step(direction) {
      var thumbs = getThumbs();
      if (!thumbs.length) return;
      var activeIndex = thumbs.findIndex(function (t) {
        return t.classList.contains('is-active');
      });
      if (activeIndex === -1) activeIndex = 0;
      var nextIndex = (activeIndex + direction + thumbs.length) % thumbs.length;
      activateThumb(thumbs[nextIndex]);
    }

    if (prevBtn) prevBtn.addEventListener('click', function () { step(-1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { step(1); });
  }

  function initForm(form) {
    if (form.dataset.lvInitialized === 'true') return;
    form.dataset.lvInitialized = 'true';

    var section = form.closest('[id^="shopify-section-"]') || document;
    var dataEl = document.getElementById('lv-produkt-data-' + form.dataset.lvDataId);
    var productData = { variants: [], moneyFormat: '€{{amount}}' };
    if (dataEl) {
      try {
        productData = JSON.parse(dataEl.textContent);
      } catch (e) {
        /* keep defaults */
      }
    }

    var kaufbox = form.closest('.lv-produkt-kauf');
    var priceEl = kaufbox ? kaufbox.querySelector('[data-lv-price]') : null;
    var compareEl = kaufbox ? kaufbox.querySelector('[data-lv-compare]') : null;
    var saleBadgeEl = kaufbox ? kaufbox.querySelector('[data-lv-sale-badge]') : null;
    var variantIdInput = form.querySelector('[data-lv-variant-id]');
    var submitBtn = form.querySelector('[data-lv-submit]');
    var submitLabel = form.querySelector('[data-lv-submit-label]');
    var msgEl = form.querySelector('[data-lv-form-msg]');
    var optionGroups = form.querySelectorAll('[data-lv-options] .lv-opt-group');
    var gallery = section.querySelector ? section.querySelector('[data-lv-gallery]') : null;

    var lastVariant = productData.variants.find(function (v) {
      return String(v.id) === String(variantIdInput ? variantIdInput.value : '');
    }) || productData.variants[0];

    function currentSelection() {
      var selected = [];
      optionGroups.forEach(function (group) {
        var idx = parseInt(group.getAttribute('data-option-index'), 10);
        var active = group.querySelector('.lv-pill.is-selected');
        selected[idx] = active ? active.getAttribute('data-value') : null;
      });
      return selected;
    }

    function setMainImage(src) {
      if (!gallery || !src) return;
      var match = null;
      var thumbs = gallery.querySelectorAll('[data-lv-thumb]');
      thumbs.forEach(function (t) {
        var isMatch = t.getAttribute('data-full') === src;
        if (isMatch) match = t;
        t.classList.toggle('is-active', isMatch);
      });
      swapMainImage(gallery.querySelector('[data-lv-main-img]'), src, match);
    }

    function updateForVariant(variant) {
      lastVariant = variant;
      var available = !!(variant && variant.available);

      if (variant && priceEl) {
        priceEl.innerHTML = formatMoney(variant.price, productData.moneyFormat);
        var onSale = !!(variant.compare_at_price && variant.compare_at_price > variant.price);
        priceEl.classList.toggle('lv-preis--sale', onSale);
        if (compareEl) {
          compareEl.hidden = !onSale;
          compareEl.innerHTML = onSale ? formatMoney(variant.compare_at_price, productData.moneyFormat) : '';
        }
        if (saleBadgeEl) saleBadgeEl.hidden = !onSale;
      }
      if (variant && variantIdInput) {
        variantIdInput.value = variant.id;
      }
      if (variant && variant.image) {
        setMainImage(variant.image);
      }

      if (submitBtn) submitBtn.disabled = !variant || !available;
      if (submitLabel) {
        if (!variant) {
          submitLabel.textContent = 'Nicht verfügbar';
        } else {
          submitLabel.textContent = available ? 'In den Warenkorb' : 'Ausverkauft';
        }
      }
    }

    if (optionGroups.length) {
      optionGroups.forEach(function (group) {
        group.querySelectorAll('.lv-pill').forEach(function (pill) {
          pill.addEventListener('click', function () {
            group.querySelectorAll('.lv-pill').forEach(function (p) {
              p.classList.remove('is-selected');
            });
            pill.classList.add('is-selected');
            var selected = currentSelection();
            var variant = findVariant(productData.variants, selected);
            updateForVariant(variant);
          });
        });
      });
    }

    var colorGroup = form.querySelector('[data-lv-color-group]');
    if (colorGroup) {
      var colorValueInput = form.querySelector('[data-lv-color-value]');
      colorGroup.querySelectorAll('.lv-pill').forEach(function (pill) {
        pill.addEventListener('click', function () {
          colorGroup.querySelectorAll('.lv-pill').forEach(function (p) {
            p.classList.remove('is-selected');
            p.setAttribute('aria-pressed', 'false');
          });
          pill.classList.add('is-selected');
          pill.setAttribute('aria-pressed', 'true');
          if (colorValueInput) colorValueInput.value = pill.getAttribute('data-value');
        });
      });
    }

    var qtyInput = form.querySelector('[data-lv-qty-input]');
    var qtyMinus = form.querySelector('[data-lv-qty-minus]');
    var qtyPlus = form.querySelector('[data-lv-qty-plus]');
    if (qtyInput && qtyMinus && qtyPlus) {
      qtyMinus.addEventListener('click', function () {
        var val = Math.max(1, (parseInt(qtyInput.value, 10) || 1) - 1);
        qtyInput.value = val;
      });
      qtyPlus.addEventListener('click', function () {
        var val = Math.max(1, (parseInt(qtyInput.value, 10) || 1) + 1);
        qtyInput.value = val;
      });
      qtyInput.addEventListener('change', function () {
        var val = Math.max(1, parseInt(qtyInput.value, 10) || 1);
        qtyInput.value = val;
      });
    }

    var charInput = form.querySelector('[data-lv-charcount]');
    var charOut = form.querySelector('[data-lv-charcount-out]');
    if (charInput && charOut) {
      var max = charInput.getAttribute('maxlength') || '';
      var updateCount = function () {
        charOut.textContent = charInput.value.length + '/' + max;
      };
      charInput.addEventListener('input', updateCount);
      updateCount();
    }

    if (gallery) {
      gallery.querySelectorAll('[data-lv-thumb]').forEach(function (thumb) {
        thumb.addEventListener('click', function () {
          gallery.querySelectorAll('[data-lv-thumb]').forEach(function (t) {
            t.classList.remove('is-active');
          });
          thumb.classList.add('is-active');
          setMainImage(thumb.getAttribute('data-full'));
        });
      });
      initGalleryArrows(gallery);
    }

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (!lastVariant || !lastVariant.available) return;

      var originalLabel = submitLabel ? submitLabel.textContent : '';
      if (submitBtn) submitBtn.disabled = true;
      if (submitLabel) submitLabel.textContent = 'Wird hinzugefügt …';
      if (msgEl) {
        msgEl.hidden = true;
        msgEl.textContent = '';
      }

      var addUrl = (window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : '/cart/add') + '.js';
      var formData = new FormData(form);

      fetch(addUrl, {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: formData
      })
        .then(function (res) {
          return res.json().then(function (data) {
            return { ok: res.ok, data: data };
          });
        })
        .then(function (result) {
          if (!result.ok) {
            throw new Error((result.data && result.data.description) || 'Der Artikel konnte nicht hinzugefügt werden.');
          }
          if (submitLabel) submitLabel.textContent = 'Hinzugefügt ✓';
          return fetch('/cart.js').then(function (r) {
            return r.json();
          });
        })
        .then(function (cart) {
          if (cart && typeof cart.item_count !== 'undefined') {
            document.querySelectorAll('.lvh-count').forEach(function (el) {
              el.textContent = cart.item_count;
            });
          }
        })
        .catch(function (err) {
          if (msgEl) {
            msgEl.textContent = err.message || 'Der Artikel konnte nicht hinzugefügt werden. Bitte versuch es erneut.';
            msgEl.hidden = false;
          }
        })
        .finally(function () {
          setTimeout(function () {
            if (submitBtn) submitBtn.disabled = !(lastVariant && lastVariant.available);
            if (submitLabel) submitLabel.textContent = originalLabel;
          }, 1800);
        });
    });
  }

  function scan(root) {
    (root || document).querySelectorAll('[data-lv-buy-form]').forEach(initForm);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      scan();
    });
  } else {
    scan();
  }

  document.addEventListener('shopify:section:load', function (e) {
    scan(e.target);
  });
})();
